module.exports = __webpack_public_path__ + "img/full5-min.02980d2a.png";